//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'OxygenIndex',
  data () {
    return {
      form: {
        FiO2: '',
        map: '',
        PaO2: ''
      },
      descTxt: '',
      hasScore: false,
      disabled: false,
      res: '...'

    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild (item, index) {
      this.form.method = item.value
    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 0
        result = form.FiO2 * (form.map / form.PaO2)
        if (result < 8) {
          self.descTxt = '轻度缺氧性呼吸衰竭'
        } else if ((result > 8 || result === 8) && result < 16) {
          self.descTxt = '中度缺氧性呼吸衰竭'
        } else if ((result > 16 || result === 16) && result < 40) {
          self.descTxt = '重度缺氧性呼吸衰竭'
        } else if (result > 40 || result === 40) {
          self.descTxt = '极重度缺氧性呼吸衰竭'
        }
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/OxygenIndex.vue